import { useQuery } from "@tanstack/react-query";
import api from "../../../../../api";
import urls from "../../../../../urls";
import type {
  DeliveryFormOptions,
  DeliveryFormOptionsResponse
} from "../DeliveryModal.types";

export function useDeliveryFormOptions(projectId: string) {
  return useQuery({
    queryKey: ["delivery-form-options", { projectId }],
    queryFn: () => fetchDeliveryFormOptions(projectId)
  });
}

async function fetchDeliveryFormOptions(projectId: string) {
  const endpointUrl = urls.api.deliveryFormOptions(projectId);
  const response = await api.get<DeliveryFormOptionsResponse>(endpointUrl);
  const options: DeliveryFormOptions = {
    sites: response.data.sites.map((site) => ({
      value: site.id,
      label: site.name
    }))
  };
  return options;
}
